module.exports = __webpack_public_path__ + "assets/view_off.dc8d5024.svg";